import i18n from "../i18n";

const Roles = {
    administrateur: i18n.t('role.administrator'),
    coach: i18n.t('role.coach'),
    moniteur: i18n.t('role.moniteur'),
    parent: i18n.t('role.parent'),
};

export default Roles;